"use strict";
exports.__esModule = true;
exports.RoomAvailability = void 0;
var RoomAvailability;
(function (RoomAvailability) {
    RoomAvailability["none"] = "None";
    RoomAvailability["noAvailability"] = "NoAvailability";
    RoomAvailability["noAvailabilityWithFilters"] = "NoAvailabilityWithFilters";
    RoomAvailability["noAvailabilityWithCrossSell"] = "NoAvailabilityWithCrossSell";
    RoomAvailability["noAvailabilityWithSelectedRoom"] = "NoAvailabilityWithSelectedRoom";
    RoomAvailability["noAvailabilityWithRoomInBasket"] = "NoAvailabilityWithRoomInBasket";
})(RoomAvailability = exports.RoomAvailability || (exports.RoomAvailability = {}));
//# sourceMappingURL=room-search.model.js.map